"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createImPalette = createImPalette;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _styles = require("@mui/material/styles");
var _paletteOptions = require("../paletteOptions");
function createImPalette(theme) {
  var muiMode = theme === 'light' || theme === 'dark' ? theme : undefined;
  var paletteOption = {
    clarity: (0, _extends2["default"])({}, _paletteOptions.baseColorPalette, {
      color: _paletteOptions.clarityColorPalette
    }),
    dark: (0, _extends2["default"])({}, _paletteOptions.baseColorPalette, {
      mode: muiMode
    }),
    light: (0, _extends2["default"])({}, _paletteOptions.baseColorPalette, {
      mode: muiMode
    }),
    midnight: (0, _extends2["default"])({}, _paletteOptions.baseColorPalette, {
      color: _paletteOptions.midnightColorPalette
    }),
    xvantage: (0, _extends2["default"])({}, _paletteOptions.baseColorPalette, {
      color: _paletteOptions.xvantageColorPalette
    })
  };
  return (0, _styles.createTheme)({
    palette: paletteOption[theme]
  }).palette;
}